export const amountPresetsOneTime = [25, 50, 100, 200, 500, 1000];
export const amountPresetsMonthly = [10, 15, 20, 25, 50, 100];

export const donationTypePresets = ["One-Time", "Monthly"];

export const donationTypes = { oneTime: "One-Time", monthly: "Monthly" };

export const donationLimits = { min: 5, max: 999999 };
